import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Design } from './components';
import useSurvey from './useSurvey';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const SurveyDesign = props => {
  const { className, ...rest } = props;
  const survey = useSurvey();
  const classes = useStyles();
  const currentBusinessContextId = useSelector(
    store => store.user.selectedBusinessContext.businessContextId
  );
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Design
          survey={survey}
          showNav={true}
          back="/surveys/details"
          next="/surveys/actions"
          currentBusinessContextId={currentBusinessContextId}
        />
      </div>
    </div>
  );
};

export default SurveyDesign;
